module.exports = __webpack_public_path__ + "img/tys_logo_white.9ed0b6f6.svg";